import React from 'react';

export default function Pagination({ page, setPage, limit, setLimit, total }) {
  const pages = Math.ceil(total / limit);

  if (total === 0) return null;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, flexWrap: 'wrap', gap: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: '.875rem', color: 'var(--text-secondary)' }}>Items per page:</span>
        <select
          className="input"
          style={{ width: 'auto', padding: '4px 8px', height: 32 }}
          value={limit}
          onChange={(e) => {
            setLimit(Number(e.target.value));
            setPage(1);
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={40}>40</option>
          <option value={100}>100</option>
        </select>
        <span style={{ fontSize: '.875rem', color: 'var(--text-secondary)' }}>
          Showing {(page - 1) * limit + 1} to {Math.min(page * limit, total)} of {total}
        </span>
      </div>

      {pages > 1 && (
        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage(p => Math.max(1, p - 1))}>←</button>
          {Array.from({ length: Math.min(5, pages) }, (_, i) => {
            const p = Math.max(1, Math.min(page - 2, pages - 4)) + i;
            return p >= 1 && p <= pages ? (
              <button key={p} className={page === p ? 'active' : ''} onClick={() => setPage(p)}>{p}</button>
            ) : null;
          })}
          <button disabled={page === pages} onClick={() => setPage(p => Math.min(pages, p + 1))}>→</button>
        </div>
      )}
    </div>
  );
}
